window.addEventListener("load", (event) => {
    productPicker();
});

function productPicker() {
    var productPicker = document.querySelector('[data-tag-id="product-picker"]');
    var productPickerMobile = document.querySelector('[data-tag-id="product-picker-mobile"]');
    var currentMenu = document.querySelectorAll('.desktop-content:not(.hide)');
    var currentMobileMenu = document.querySelectorAll('.sub-menu.current-menu');

    if (productPicker) {

        if (currentMenu.length > 0) {
            var shouldDisplay = currentMenu[0].getAttribute('data-menu-productpicker');

            if (shouldDisplay) {

                if (productPicker.classList.contains('hide')) {
                    productPicker.classList.remove('hide');
                }
            } else {
                productPicker.classList.add('hide');
            }
        }

        if (currentMobileMenu.length > 0) {
            var shouldDisplay = currentMobileMenu[0].getAttribute('data-menu-productpicker');

            if (shouldDisplay) {
                if (productPickerMobile.classList.contains('hide')) {
                    productPickerMobile.classList.remove('hide');
                }
            } else {
                productPickerMobile.classList.add('hide');
            }
        }
    }
}

function toggleMainMenu() {

    var bodyTag = document.getElementsByTagName("body")[0];
    var menu = document.getElementById("Meny");
    var logo = document.getElementById("logo");
    var menuBackButton = document.getElementById("menu-back");
    var currentMenu = document.getElementsByClassName("current-menu");
    var hamburgerTag = document.getElementsByClassName("nav-responsive-button")[0];
    var hamburger = hamburgerTag.querySelector("img");

    if (menu) {
        var isOpen = menu.classList.contains("open");

        if (isOpen) {
            menuBackButton.classList.add("hide");
            menu.classList.remove("open");
            logo.classList.remove("hidden");
            bodyTag.classList.remove("lock-scroll")
            hamburger.src = "/images/hamburger.svg";
        } else {
            if (currentMenu.length > 0) {
                menuBackButton.classList.remove("hide");
            }
            menu.classList.add("open");
            logo.classList.add("hidden");
            bodyTag.classList.add("lock-scroll");
            hamburger.src = "/images/close-search.svg";
            productPicker();
        }
    }
}

function toggleMenu(id, newCategoryName, currentCategoryName) {
    var nameTag = document.getElementById("category-name");
    var menu = document.getElementById(id);
    var currentOpenMenus = document.getElementsByClassName("current-menu");
    var inner = document.getElementById("menu-content");
    var backButton = document.getElementById("menu-back");
    var menuBackText = document.getElementById("menu-back-text");
    var previousCategory = document.getElementById("previous-category");
    var parent;


    previousCategory.innerText = currentCategoryName;

    if (currentOpenMenus.length > 0) {
        for (var i = 0; i < currentOpenMenus.length; i++) {
            currentOpenMenus[i].classList.remove("current-menu");
        }

    }

    if (nameTag) {
        nameTag.innerText = "";
    }

    if (menu) {

        if (menu.parentElement) {
            parent = menu.parentElement;
        }
        inner.innerHTML = menu.innerHTML;

        for (var i = 0; i < inner.getElementsByClassName("sub-menu").length; i++) {
            inner.getElementsByClassName("sub-menu")[i].removeAttribute("id");
        }
        if (menu.classList.contains("current-menu")) {
            menu.classList.remove("current-menu");
        } else {
            menu.classList.add("current-menu")
            productPicker();
            if (newCategoryName.length > 0) {
                nameTag.style.display = "inital";
                nameTag.innerHTML = newCategoryName.replace(/-\d+$/, '');
                nameTag.setAttribute('data-name', newCategoryName)
                backButton.classList.remove("hide");
                menuBackText.innerText = parent.id.replace(/-\d+$/, '');

            } else {
                backButton.classList.add("hide");
            }
        }
    
    }
}

function menuBack(e) {
    var currentMenu = document.getElementsByClassName("current-menu");
    var currentId = document.getElementById("category-name").getAttribute('data-name')
    var menuItems = document.querySelectorAll("div.sub-menu");
    var parent;

    if (currentMenu.length > 0) {
        
        for (var i = 0; i < currentMenu.length; i++) {
            currentMenu[i].classList.remove("current-menu");
        }

        for (var i = 0; i < menuItems.length; i++) {
            if (menuItems[i].id == `${currentId}`) {
                parent = menuItems[i].parentElement.id;
            } 
        }


        var newCategoryName = parent;

        if (parent == "Meny") {
            newCategoryName = "";
            parent = "default";
        }


        toggleMenu(parent, newCategoryName, newCategoryName);
    }
}

function toggleDesktopMenu(id, button) {
    var target = document.getElementById(id);
    var menu = document.getElementsByClassName("desktop-menu");
    var openDesktopMenues = document.getElementsByClassName("current-desktop-menu");
    var desktopContent = document.getElementsByClassName("desktop-content");
    var navLinks = document.getElementsByClassName("nav-link");
    var bodyTag = document.getElementsByTagName("body")[0];
    var closeMenu = false;

    for (var i = 0; i < desktopContent.length; i++) {
        desktopContent[i].classList.add("hide");
    }

    if (openDesktopMenues.length > 0) {
        for (var i = 0; i < openDesktopMenues.length; i++) {
            if (openDesktopMenues[i] == button) {
                closeMenu = true;
            }
            openDesktopMenues[i].classList.remove("current-desktop-menu");
        }
    }

    button.classList.add("current-desktop-menu");


    if (target) {
        if (menu.length > 0 && !closeMenu) {
            menu[0].classList.remove("hide");
        }
    }

    target.classList.remove("hide");

    if (closeMenu) {
        if (target) {
            if (menu) {
                var menuTag = menu[0];

                if (menuTag) {
                    menuTag.classList.add("hide");
                    if (openDesktopMenues.length > 0) {
                        for (var i = 0; i < openDesktopMenues.length; i++) {
                            openDesktopMenues[i].classList.remove("current-desktop-menu");
                        }

                        for (var i = 0; i < navLinks.length; i++) {
                            navLinks[i].classList.remove("inactive");
                        }
                        bodyTag.classList.remove("lock-scroll");
                    }
                }
            }
        }
    } else {
        for (var i = 0; i < navLinks.length; i++) {
            navLinks[i].classList.add("inactive");
        }

        bodyTag.classList.add("lock-scroll");
        button.classList.add("current-desktop-menu");
        productPicker();
    }

    
}

window.toggleMainMenu = toggleMainMenu;
window.menuBack = menuBack;
window.toggleDesktopMenu = toggleDesktopMenu;
window.toggleMenu = toggleMenu;
